module.exports = __webpack_public_path__ + "img/business_4.8ca9ba70.jpg";